import { type FieldType, type ISubJobIndex } from '@/interfaces'

export class SubJobIndex implements ISubJobIndex {
	[key: string]: FieldType
	id: number
	jobId: number
	subjobNumber: string
	name: string
	startDate: Date
	dueDate: Date
	status: string
	buildLocation: string
	booth: string
	timeline: string
	estimatedContractValue: number
	subjobType: number
	contractingState: string
	contractingStateAlias: string
	productionState: string
	productionStateAlias: string
	jobNumber: string
	clientId: string
	clientName: string
	salesTeam: number

	// User tracking fields
	createBy: number
	createByEmail: string
	createByName: string
	updateBy: number
	updateByEmail: string
	updateByName: string

	// Financial fields
	unbilled: number
	unbilledGrandTotal: number
	estimatedTotalAmt: number
	estimatedCMAmt: number
	estimatedCMPct: number
	postedCMAmt: number
	postedCMPct: number
	quoteDraftTotal: number
	quoteUnsignedTotal: number
	contractSubtotal: number
	contractGrandTotal: number
	invoiceSubtotal: number
	openARSubtotal: number
	postedTotalAmt: number
	percentBilled: number
	billingStatus: string

	constructor({
		id,
		jobId,
		subjobNumber,
		name,
		startDate,
		dueDate,
		status,
		buildLocation,
		booth,
		timeline,
		estimatedContractValue,
		subjobType,
		contractingState,
		contractingStateAlias,
		productionState,
		productionStateAlias,
		jobNumber,
		clientId,
		clientName,
		salesTeam,
		createBy,
		createByEmail,
		createByName,
		updateBy,
		updateByEmail,
		updateByName,
		unbilled,
		unbilledGrandTotal,
		estimatedTotalAmt,
		estimatedCMAmt,
		estimatedCMPct,
		postedCMAmt,
		postedCMPct,
		quoteDraftTotal,
		quoteUnsignedTotal,
		contractSubtotal,
		contractGrandTotal,
		invoiceSubtotal,
		openARSubtotal,
		postedTotalAmt,
		percentBilled,
		billingStatus
	}: ISubJobIndex) {
		this.id = id
		this.jobId = jobId
		this.subjobNumber = subjobNumber
		this.name = name
		this.startDate = startDate
		this.dueDate = dueDate
		this.status = status
		this.buildLocation = buildLocation
		this.booth = booth
		this.timeline = timeline
		this.estimatedContractValue = estimatedContractValue
		this.subjobType = subjobType
		this.contractingState = contractingState || ''
		this.contractingStateAlias = contractingStateAlias || ''
		this.productionState = productionState || ''
		this.productionStateAlias = productionStateAlias || ''
		this.jobNumber = jobNumber
		this.clientId = clientId
		this.clientName = clientName
		this.salesTeam = salesTeam

		// User tracking fields
		this.createBy = createBy
		this.createByEmail = createByEmail || ''
		this.createByName = createByName || ''
		this.updateBy = updateBy
		this.updateByEmail = updateByEmail || ''
		this.updateByName = updateByName || ''

		// Financial fields
		this.unbilled = unbilled || 0
		this.unbilledGrandTotal = unbilledGrandTotal || 0
		this.estimatedTotalAmt = estimatedTotalAmt || 0
		this.estimatedCMAmt = estimatedCMAmt || 0
		this.estimatedCMPct = estimatedCMPct || 0
		this.postedCMAmt = postedCMAmt || 0
		this.postedCMPct = postedCMPct || 0
		this.quoteDraftTotal = quoteDraftTotal || 0
		this.quoteUnsignedTotal = quoteUnsignedTotal || 0
		this.contractSubtotal = contractSubtotal || 0
		this.contractGrandTotal = contractGrandTotal || 0
		this.invoiceSubtotal = invoiceSubtotal || 0
		this.openARSubtotal = openARSubtotal || 0
		this.postedTotalAmt = postedTotalAmt || 0
		this.percentBilled = percentBilled || 0
		this.billingStatus = billingStatus || ''
	}

	get jobType(): string {
		switch (this.subjobType) {
			case 1:
				return 'Service'
			case 2:
				return 'Rental'
			case 3:
				return 'Events'
			case 4:
				return 'Build'
			case 5:
				return 'International'
			case 6:
				return 'No Cost'
			case 7:
				return 'Internal'
			case 8:
				return 'Digital'
			case 9:
				return 'Portables'
			default:
				return ''
		}
	}

	get jobStatus(): string {
		switch (this.status) {
			case 'C':
			case 'N':
				return 'Canceled'
			case 'P':
				return 'Paused'
			case 'T':
				return 'Stopped'
			case 'F':
				return 'Finished'
			case 'S':
				return 'Started'
			case 'O':
				return 'Open'
			default:
				return ''
		}
	}
}
